export interface RadioItem<V = string> {
  value: V
  label?: string
}

export enum RadioItemSize {
  NORMAL = 'normal',
  LARGE = 'large',
}

export enum RadioItemLayout {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
